module.exports = __webpack_public_path__ + "img/contributions40Off.a24f0c99.svg";